import { EncodeOAuthStateParams } from '@modules/integrationsV2/utils/encodeOAuthState';

export const decodeOAuthState = (state: string) => {
  if (!state) {
    return undefined;
  }
  const jsonBuffer = Buffer.from(state, 'base64');
  try {
    const parsedJSON: EncodeOAuthStateParams = JSON.parse(
      jsonBuffer.toString(),
    );
    return parsedJSON;
  } catch {
    return undefined;
  }
};
